module.exports = __webpack_public_path__ + "img/england_qrcode_1.c22c27ab.jpg";